@if (isStaff) {
  <div class="controls">
    <div class="filters">
      @for (statusType of statuses; track statusType) {
        <a class="poll-status-selector" href="javascript:;"
          [class.active]="status == statusType" (click)="switchStatus(statusType)">
          {{humanizeStatus(statusType)}}
        </a>
      }
    </div>
    <a mat-raised-button color="primary" routerLink="/reports/edit/new">
      New
    </a>
  </div>
}

<h1>Stories</h1>

@if (!articles) {
  <app-spinner></app-spinner>
}

@if (articles) {
  @for (article of articles; track article) {
    <tyt-article-list-item [article]="article" [showImage]="false" [showFranchise]="false"
    [showFranchiseInByLine]="true"></tyt-article-list-item>
  }
  @if (articles.length > 0) {
    <tyt-pager [total]="total" [page]="page" [size]="pageSize" (changePage)="goToPage($event)"></tyt-pager>
  }
}